import React, { memo } from 'react';
import {
  Stack,
  Typography,
  CardContent,
  Card,
  Box,
  Divider,
  Button,
  Icon
} from 'investira.react.components';
import { Link } from 'react-router-dom';
import { displays } from 'investira.react.lib';
import { PessoaImage } from '../../../components/molecules';
import utils from '../../../utils';

const AtivoGestorAdministrador = memo(props => {
  const { pessoa, ativo } = props;

  if (!['FND'].includes(ativo.mercado)) {
    return null;
  }
  return (
    <Stack flexGrow={1}>
      {/* <Stack
        spacing={2}
        direction="row"
        justifyContent={"space-between"}
        sx={{ py: 1 }}
      > */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            lg: 'repeat(2, 1fr)'
          },
          gap: 1.5
        }}>
        <Stack flexGrow={1}>
          <Card>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={3} mb={2}>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    <b>Gestor</b>
                  </Typography>
                </Stack>
                <Stack flexGrow="1"></Stack>
                {ativo.gestor_pessoa_id && (
                  <Stack>
                    <Button
                      component={Link}
                      title={ativo.gestor?.pessoa_fantasia}
                      endIcon={<Icon iconName="arrow-next" size={12} />}
                      size="small"
                      to={`/empresas/${ativo.gestor_pessoa_id}`}
                      sx={{ px: 2, textTransform: 'capitalize' }}>
                      {`${utils.typo.shortname(ativo.gestor?.pessoa_fantasia || '', 20)}`}
                    </Button>
                  </Stack>
                )}
              </Stack>
              <Stack direction="row" alignItems="center" spacing={3}>
                <Stack>
                  <PessoaImage
                    logoPessoaId={ativo.gestor_pessoa_id}
                    alt={pessoa.pessoa}
                    hasLogo={ativo.logo_ok}
                    size={36}
                  />
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    Nome Fantasia
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 600 }}>
                    {ativo.gestor?.pessoa_fantasia || '--'}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    CNPJ
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 600 }}>
                    {displays.cnpj(ativo.gestor?.cnpj) || '--'}
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Stack>

        <Stack flexGrow={1}>
          <Card>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={3} mb={2}>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    <b>Administrador</b>
                  </Typography>
                </Stack>
                <Stack flexGrow="1"></Stack>
                {ativo.adm_pessoa_id && (
                  <Stack>
                    <Button
                      component={Link}
                      title={ativo.adm?.pessoa_fantasia}
                      endIcon={<Icon iconName="arrow-next" size={12} />}
                      size="small"
                      to={`/empresas/${ativo.adm_pessoa_id}`}
                      sx={{ px: 2, textTransform: 'capitalize' }}>
                      {`${utils.typo.shortname(ativo.adm?.pessoa_fantasia || '', 20)}`}
                    </Button>
                  </Stack>
                )}
              </Stack>
              <Stack direction="row" alignItems="center" spacing={3}>
                <Stack>
                  <PessoaImage
                    logoPessoaId={ativo.adm?.logo_pessoa_id}
                    alt={ativo.adm?.pessoa_fantasia}
                    hasLogo={ativo.adm?.logo_ok || false}
                    size={36}
                  />
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    Nome Fantasia
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 600 }}>
                    {ativo.adm?.pessoa_fantasia || '--'}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    CNPJ
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 600 }}>
                    {displays.cnpj(ativo.adm?.cnpj) || '--'}
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Box>
      {/* </Stack> */}
      {/* <Divider /> */}
    </Stack>
  );
});

export default AtivoGestorAdministrador;
